<script>
import Layout from "@/components/pages/layouts/vertical";
import {mapActions} from "vuex";

/**
 * Contact Component
 */
export default {
  components: { Layout },
  data() {
    return {
      form: {
        email: '',
        name: '',
        text: '',
        topic: null
      },
      topics: [
        { text: 'Select One', value: null },
        { text: 'Scheduling', value: 'scheduling@mypropertyvault.com' },
        { text: 'Technical Support', value: 'techsupport@mypropertyvault.com' },
        { text: 'Billing Support', value: 'orderinfo@mypropertyvault.com' },
        { text: 'Sales Support', value: 'salesteam@mypropertyvault.com' }
      ],
      show: true
    }
  },
  methods: {
    ...mapActions("email", ["sendSupportEmail"]),
    trySendEmail(){
      if (!this.form.topic) return;

      const payload = {
        email: {
          from: this.form.email,
          name: this.form.name,
          subject: 'New Support Request',
          to: this.form.topic,
          body: this.form.text
        }
      };

      this.sendSupportEmail(payload)
        .then(()=> {
          this.form.email = '';
          this.form.text = '';
          this.form.topic = '';
          this.form.name = '';
        });
    }
  }
};
</script>

<style>
  .contact-form {
    margin-bottom: 1rem;
    margin-left: 16px;
  }

  .form-control {
    max-width: 600px;
  }

  .form-group, 
  .text-box.form-control {
    margin-bottom: 1rem;
  }
</style>

<template>
  <Layout>
    <div>
      <h1>Contact Us</h1>
      <p>For all inquiries, please use the contact form below.</p>
      <b-form class="contact-form" @submit.stop.prevent="trySendEmail" v-if="show">
        <b-form-group
          id="input-group-1"
          label="Email"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            placeholder="Enter email"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Name" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            placeholder="Enter name"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="How can we help?" label-for="input-3">
          <b-form-select
            id="input-3"
            v-model="form.topic"
            :options="topics"
            required
          ></b-form-select>
        </b-form-group>
        
        <b-form-textarea
          id="input-4"
          class="text-box" 
          v-model="form.text"
          placeholder="Enter something..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>

        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>
    </div>
  </Layout>
</template>
